import React, { useEffect, useState } from "react";
import * as S from "../BlockEditor/styles";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchPaper,
  updatePaper,
  replacePaperOriginal,
} from "../../api/adminApi";
import { useToast } from "../../context/ToastContext";
import PaperFields from "./components/PaperFields";
import PaperOriginalModal from "./components/PaperOriginalModal";

const PaperEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const paperId = Number(id);
  const toast = useToast();
  const [paper, setPaper] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    text: "",
    lists: "",
    original: "",
  });

  // General state
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Image replacement state
  const [showOriginalModal, setShowOriginalModal] = useState(false);
  const [uploadingOriginal, setUploadingOriginal] = useState(false);

  const loadAll = async () => {
    setLoading(true);
    try {
      const [data] = await Promise.all([fetchPaper(paperId)]);

      setPaper(data);
      setFormData({
        name: data.name || "",
        text: data.text || "",
        lists: data.lists || "",
        original: data.original || "",
      });
    } catch (err) {
      toast.error("Ошибка загрузки данных");
    } finally {
      setLoading(false);
    }
  };

  const handleSavePaper = async () => {
    setSaving(true);
    try {
      await updatePaper(paperId, {
        name: formData.name,
        text: formData.text,
        lists: formData.lists,
        original: formData.original || null,
      });
      toast.success("Тип бумаги сохранён");
    } catch (err) {
      toast.error("Ошибка сохранения");
    } finally {
      setSaving(false);
    }
  };

  const handleOriginalClick = () => {
    setShowOriginalModal(true);
  };

  const handleOriginalFileSelect = async (file) => {
    setUploadingOriginal(true);
    try {
      const updated = await replacePaperOriginal(paperId, file);
      setPaper(updated);
      setFormData((prev) => ({
        ...prev,
        original: updated.original || "",
      }));
      setShowOriginalModal(false);
      toast.success("Изображение типа бумаги обновлено");
    } catch (err) {
      toast.error("Ошибка загрузки изображения");
    } finally {
      setUploadingOriginal(false);
    }
  };

  const showMessage = (text, type) => {
    if (type === "error") {
      toast.error(text);
    } else {
      toast.success(text);
    }
  };

  // Load all data on mount
  useEffect(() => {
    loadAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paperId]);

  if (loading) return <S.Loading>Загрузка...</S.Loading>;
  if (!paper) return <S.Loading>Тип бумаги не найден</S.Loading>;

  return (
    <S.Container>
      <S.Header>
        <S.PageTitle
          as="button"
          onClick={() => navigate("/opredelitel/admin/papers")}
        >
          Типы бумаги
        </S.PageTitle>
        -<S.PageTitle>{paper.name}</S.PageTitle>
      </S.Header>

      <PaperFields
        formData={formData}
        setFormData={setFormData}
        handleSavePaper={handleSavePaper}
        saving={saving}
        showMessage={showMessage}
        handleOriginalClick={handleOriginalClick}
      />

      <PaperOriginalModal
        isOpen={showOriginalModal}
        onClose={() => {
          if (!uploadingOriginal) setShowOriginalModal(false);
        }}
        onFileSelect={handleOriginalFileSelect}
        uploading={uploadingOriginal}
        hasOriginal={Boolean(formData.original)}
      />
    </S.Container>
  );
};

export default PaperEditor;
